import Vue from '_lib/_vue'
import App from './index.vue'
import { articlePlatformPlugin } from '../post-article/platform/share/main'
import VueDeepLink from './assets/plugin/deepLink'
import HeyboxIcon from '_lib/plugin/heybox-icon'

Vue
  .use(articlePlatformPlugin)
  .use(VueDeepLink)
  .use(HeyboxIcon) 

new Vue({
  render: h => h(App),
}).$mount('#app')

